import React from 'react'
import { Link } from 'react-router-dom'
import './css/Hero_section.css'

export default function Hero_section() {
    const linkedin = () => {
            window.open(
              'https://www.linkedin.com/in/rohith-kumar-543b00193/',
              '_blank' 
            )
      }
    const git = () => {
            window.open(
              'https://github.com/rohith-001',
              '_blank' 
            )
      }
        const Behance = () => {
            window.open(
              'https://www.behance.net/rohithkumar2',
              '_blank' 
            )
      }
    return (

<div className="container-fluid">
        <div className="row align-items-center">
            <div className="col-sm-6 order-sm-2">
            <img  id="bg_home" src={require('../Images/bg_home.png')} className="img-fluid" alt="i'm Rohith"/>

            </div>
            <div className="col-sm-6 pl-sm-5" id="fs">
                <p className="h1 fopri">I'm a</p>
                <div id="change" className="text-light bg-dark h1 fopri">
                <div id="line">UX DESIGNER</div>
                <div id="line">UI DESIGNER</div>
                <div id="line">DEVELOPER</div>
                </div>

                <br/>
                <p className="h4 text-muted text-justify" id="detail">Ux unicorn is Someone who is good at all aspects of UX design, Graphic design, and coding. I want to become a ux unicorn. Even though i am not an expert i am a good learner and listener who always tried to reach new horizon</p>
                {/* <p className="text-danger">This site is not fully ready</p> */}
                <br/>
                <Link onClick={linkedin} className="font-weight-bold text-decoration-none text-dark" to="">Linkedin&nbsp;</Link><span className="text-muted"> &nbsp; </span><Link onClick={git} to="" className="font-weight-bold text-decoration-none text-dark">&nbsp;Github</Link><span className="text-muted"> &nbsp; </span><Link onClick={Behance} className="font-weight-bold text-decoration-none text-dark" to="">Behance&nbsp;</Link>
            </div>
        </div>
      </div>
    )
}
